import { createApi } from '@reduxjs/toolkit/query/react';
import { sortAsc } from '@strata/helper-functions';

import { REFERENCE_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const referenceApi = createApi({
    baseQuery: getBaseQuery(REFERENCE_API_URL),
    reducerPath: 'referenceApi',
    endpoints: (build) => ({
        /** Gets list of payer segments */
        getPayerSegments: build.query({
            query: () => 'payer_segments',
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving health plans.',
            ),
            transformResponse: (response) => {
                const payerSegmentList = response
                    .map((segment) => ({
                        name: segment.segment_name,
                        secondaryData: segment.segment_id,
                        ...segment,
                    }))
                    .sort((a, b) => sortAsc(a.name, b.name));
                const payerSegmentMap = Object.fromEntries(
                    (payerSegmentList ?? []).map((segment) => [segment.segment_id, segment]),
                );
                return { payerSegmentList, payerSegmentMap };
            },
        }),
        getProductConfigForPayer: build.query({
            query: ({ segmentId, productServiceOid }) => ({
                url: `product_benefit_configs/${segmentId}/${productServiceOid}`,
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving eligible suppliers.',
            ),
            transformResponse: (response) =>
                response.map((config) => ({
                    additionalMedOptions: config.additional_med_options,
                    directionOptions: config.direction_options,
                    hcpcsBillingLabel: config.hcpcs_billing_label,
                    hcpcsPackageSize: config.hcpcs_package_size,
                    ndcBillingLabel: config.ndc_billing_label,
                    ndcPackageSize: config.ndc_package_size,
                    payerId: config.payer_id,
                    preferredBillingType: config.preferred_billing_type,
                    productServiceOid: config.product_service_oid,
                    validSitesOfCare: config.valid_sites_of_care,
                    facilities: config.facilities,
                })),
        }),
    }),
});

export const { useGetProductConfigForPayerQuery, useGetPayerSegmentsQuery } = referenceApi;
